import dynamic from 'next/dynamic';

const loadBarcodeScanner = () => import('./barcode-scanner');

const BarcodeScanner = dynamic(loadBarcodeScanner, { ssr: false });

/** Prefetch Quagga scanner chunk on hover/focus/idle. */
export function preloadBarcodeScanner() {
  void loadBarcodeScanner();
}

export default BarcodeScanner;
